import lodash from 'lodash'
import React, { ReactElement } from 'react'
import styled from 'styled-components'

import Alert from '../../../../1stlog-ui/src/components/Alert'

const Wrapper = styled.div``

type TProps = {
  error?: { status: number; data: { message: string } }
  setError: (object) => void
}

const Error = (props: TProps): ReactElement => {
  const { error, setError } = props

  const dismiss = (): void => setError(undefined)

  if (!error) {
    return <></>
  }

  const { status, data } = error

  if (status >= 400 && status < 500) {
    const message = lodash.get(data, 'message')

    return (
      <Wrapper>
        <Alert dismissible danger onClose={dismiss}>
          <strong>{i18n.t('error', 'Fehler')}:</strong>{' '}
          {i18n.t('order_entry_error_with_message', {
            message,
            defaultValue:
              'Der Auftrag konnte nicht übermittelt werden ({{message}}). Bitte überprüfen Sie das Formular und versuchen Sie es erneut.',
          })}
        </Alert>
      </Wrapper>
    )
  }

  if (status >= 500) {
    return (
      <Wrapper>
        <Alert dismissible danger onClose={dismiss}>
          <strong>{i18n.t('error', 'Fehler')}:</strong>{' '}
          {i18n.t('order_entry_error_without_message', {
            defaultValue:
              'Beim Übermitteln des Auftrages ist ein Fehler aufgetreten. Dieser wurde den Entwicklern gemeldet. Falls Sie diesen Fehler wiederholt sehen, kontaktieren Sie bitte Ihren Administrator.',
          })}
        </Alert>
      </Wrapper>
    )
  }

  return <></>
}

export default Error
